import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router , ActivatedRoute} from '@angular/router';
import { SDGComponent, Result, ResultData, QuestionCategoryGroup, QuestionCategoryType, QuestionType } from '../../_models/index';
import { AlertService, SDGComponentService, ResultService } from '../../_services/index';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../environments/environment';
import * as $ from 'jquery';

var COMP = environment.component.finance;

@Component({
  selector: 'app-finance-data',
  templateUrl: './finance-data.component.html',
  styleUrls: ['./finance-data.component.css']
})
export class FinanceDataComponent implements OnInit, OnDestroy {
  sdgcomponent$ : Observable<SDGComponent>;
  results$ : Observable<ResultData[]>;
  subscription1:Subscription;
  subscription2:Subscription;
  qcgroups : Array<QuestionCategoryGroup>=[];
  qctypes : Array<any>=[];
  qtypes : Array<any>=[];
  qctypes_new : Array<any>=[];
  qtypes_new : Array<any>=[];
  rows: Array<Object>=[];
  rowsobj: Object;
  qtindexobj: Object;
  qtindexrevarr: Array<Object>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sdgComponentService: SDGComponentService,
    private alertService: AlertService,
    private resultService: ResultService) { }

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".finance-click").addClass("header_active")

    this.results$ = this.resultService.getResultData(COMP);
    this.sdgcomponent$ = this.sdgComponentService.getAll(COMP);
    this.subscription1 = this.sdgcomponent$.subscribe( data => {
          var qtindex = 0;
          var qtindexobj = {};
          var qtindexrevarr = [];
          var qct:any = data['question_category_type'];
          this.qctypes = Array.apply(null, Array(qct.length)).map(function () {});

          //create an array of question category types using order as array index
          var af_qct,nf_qct,af_qct_pos,
              f11_qct1,f11_qct_pos,
              f13_qct1,f13_qct_pos;
          for (var i=0; i < qct.length; i++){
            var span = qct[i].question_type.length;

            if(span > 1) span += 1;

            this.qctypes[qct[i].order-1] = {"name":qct[i].name,"display_text":qct[i].display_text,"span":span,"question_type":qct[i].question_type,
              "category_group":qct[i].category_group, "order":qct[i].order,
              "average": qct[i].average, "positive_response_percent": qct[i].positive_response_percent }
            if (qct[i].name == "f3"){
              af_qct = {"name":"af","display_text":"Gap in funding in the current year (000,000 USD)","span":span,"question_type":"",
              "category_group":'Adequacy of financial flows to meet target in 2016', "order":qct[i].order,
              "average": qct[i].average, "positive_response_percent": qct[i].positive_response_percent }
              nf_qct = {"name":"nf","display_text":"Total available funds as % of funds needed in the current year","span":span,"question_type":"",
              "category_group":'Adequacy of financial flows to meet target in 2016', "order":qct[i].order,
              "average": qct[i].average, "positive_response_percent": qct[i].positive_response_percent }
              af_qct_pos = qct[i].order;
            } else if (qct[i].name == "f11"){
              f11_qct1 = {"name":"","display_text":"Proportion of positive responses for 'financial flows'","span":span,"question_type":"",
              "category_group":'Adequacy of financial flows to meet target in 2016', "order":qct[i].order,
              "average": qct[i].average, "positive_response_percent": qct[i].positive_response_percent }
              f11_qct_pos = qct[i].order;
            } else if (qct[i].name == "f18"){
              f13_qct1 = {"name":"","display_text":"Proportion of positive responses for 'funding sources'","span":span,"question_type":"",
              "category_group":'Attracting funding sources in 2016', "order":qct[i].order,
              "average": qct[i].average, "positive_response_percent": qct[i].positive_response_percent }
              f13_qct_pos = qct[i].order;
            }
          }
          //Add additional question category types
          if (af_qct_pos){
            this.qctypes.splice(af_qct_pos,0,af_qct,nf_qct);
          }
          if (f11_qct_pos){
            this.qctypes.splice(f11_qct_pos+2,0,f11_qct1);
          }
          if (f13_qct_pos){
            this.qctypes.splice(f13_qct_pos+3,0,f13_qct1);
          }

          //slice the last element is for Pool
          this.qctypes.splice(-1,1);

          //create an array of question category type groups
          var qcgroup=this.qctypes[0].category_group;
          var groupspan=0;
          for (var i=0; i < this.qctypes.length; i++){
            if(this.qctypes[i].category_group == qcgroup){
              groupspan += this.qctypes[i].span;
            }
            else{
              this.qcgroups.push({"name":qcgroup,"span":groupspan});
              qcgroup = this.qctypes[i].category_group;
              groupspan = this.qctypes[i].span;
            }
          }
          this.qcgroups.push({"name":qcgroup,"span":groupspan});

         //create an array of question types using order as array index going through all qctypes and all qtypes within each qctype
          for (var i=0; i < this.qctypes.length; i++){

            var qctypeobj = this.qctypes[i];
            var qtarr = this.qctypes[i].question_type;
            if (qctypeobj.name == "f13"){
              for (var m=0; m < qtarr.length; m++)
                if(qtarr[m].name == "f13d")
                qtarr.splice(m, 1);
            }
            //create an array of qtypes in one qctype
            var arr = Array.apply(null, Array(qtarr.length)).map(function () {});
            for (var j=0; j < qtarr.length; j++)
              arr[qtarr[j].order-1] = {id:qtarr[j].id,"name":qtarr[j].name,order:qtarr[j].order, display_text: qtarr[j].display_text};

            //add above qtypes into the lookup table for qtypeid => qtypeindex (column order)
            //and reverse lookup columnorder => qtype
debugger;
            for (var k=0; k < arr.length; k++){
//              if(arr[k].name != 'f13d'){
                this.qtypes.push(arr[k]);
                qtindexobj[arr[k].id] = qtindex;
                qtindexrevarr[qtindex] = arr[k].name;
                qtindex++;
//              }
            }
            if (qctypeobj.name == "f3"){
              this.qtypes.push({id:0,"name":"Gap in funding - 2016 ('000,000 USD)",order:this.qtypes[this.qtypes.length-1].order, display_text: "Gap in funding in the current year (000,000 USD)"});
              qtindexrevarr[qtindex] = "Gap in funding - 2016 ('000,000 USD)";
              qtindex++;
              this.qtypes.push({id:0,"name":"Total available funds as % of funds needed in 2016",order:this.qtypes[this.qtypes.length-1].order, display_text: "Total available funds as % of funds needed in the current year"});
              qtindexrevarr[qtindex] = "Total available funds as % of funds needed in 2016";
              qtindex++;
            } else if (qctypeobj.name == "f11"){
              this.qtypes.push({id:0,"name":"Proportion of positive responses for 'financial flows'",order:this.qtypes[this.qtypes.length-1].order, display_text: "Proportion of positive responses for 'financial flows'"});
              qtindexrevarr[qtindex] = "Proportion of positive responses for 'financial flows'";
              qtindex++;
            } else if (qctypeobj.name == "f13"){
              this.qtypes.push({id:0,"name":"Proportion of positive responses for 'accountability'",order:this.qtypes[this.qtypes.length-1].order, display_text: "Proportion of positive responses for 'accountability'"});
              qtindexrevarr[qtindex] = "Proportion of positive responses for 'accountability'";
              qtindex++;
            } else if (qctypeobj.name == "f18"){
              this.qtypes.push({id:0,"name":"Proportion of positive responses for 'funding sources'",order:this.qtypes[this.qtypes.length-1].order, display_text: "Proportion of positive responses for 'funding sources'"});
              qtindexrevarr[qtindex] = "Proportion of positive responses for 'funding sources'";
              qtindex++;
            } else if (qctypeobj.name == "f20"){
              this.qtypes.push({id:0,"name":"Proportion of positive responses for 'funding for equity'",order:this.qtypes[this.qtypes.length-1].order, display_text: "Proportion of positive responses for 'funding equity'"});
              qtindexrevarr[qtindex] = "Proportion of positive responses for 'funding for equity'";
              qtindex++;
            }

          }
         this.qtindexobj = qtindexobj;
         this.qtindexrevarr = qtindexrevarr;
          function label_name(ct){
            return ct.name.replace("Target ","").replace("Indicator ","");
          }
          var ctar = data['category'];
          var rows = {};
          var row = {};
          for (var c = 0; c < ctar.length; c++){
            var ct = ctar[c];
            row["catname"] = label_name(ct);
            var scl = ct.sub_category.length;
            row["rowspan"] = scl;
            var catrow1 = true;
            for (var sc = 0; sc < scl; sc++){
              var newrow = {catname:row["catname"], rowspan:row["rowspan"]};
              var sct = ct.sub_category[sc];
              newrow["subcatname"] = label_name(sct);
              newrow["catrow"] = catrow1;
              if(sct.order == 2)
                newrow["rowspan"] = 0;
              catrow1 = false;
              var resultsarr = Array.apply(null, Array(qtindex)).map(function () {});
              newrow["resultsarr"] = resultsarr;
              rows[sct.id] = newrow;
            }
          }
          this.rowsobj = rows;
          this.subscription2 = this.results$.subscribe( data => {
               for(var i=0;i<data.length;i++){
                 var res = data[i];
                 if(res.question_type_name == "f13d") continue;
                 var colidx = this.qtindexobj[res.question_type];
                 this.rowsobj[res.sub_category].resultsarr[colidx] = res;
               }
                //go through each row
               var data_valid;
               for(var ri in this.rowsobj){
                 data_valid = true;
                 var rowresults = this.rowsobj[ri].resultsarr;
                 var qcat_count = 0, weight_sum = 0, all_3 = true, none_1 = false, count_1 = 0, count_non_empty = 0;
                 var curr_qcat_name = "", f3_counter = 0, available_funds = 0, needed_funds = 0,
                     all_3_flows = true, count_1_flows = 0, all_3_accountability = true, count_1_accountability = 0,
                     all_3_sources = true, count_1_sources = 0, all_3_equity = true, count_1_equity = 0;
                 //go through each result in the row
                 for(var rri = 0; rri < rowresults.length; rri++){
                   var resobj = rowresults[rri];
                   if(resobj)
                     curr_qcat_name = resobj.question_category_type_name;
                   if(curr_qcat_name == "f2"){
                      available_funds = parseInt(resobj.value);
                   }
                   else if(curr_qcat_name == "f3"){
                    if (resobj){
                      if (f3_counter == 0){
                        needed_funds = parseInt(resobj.value);
                      }
                    } else {
                      if (f3_counter == 1){
                        rowresults[rri] = {value:needed_funds-available_funds}
                      } else {
                        rowresults[rri] = {value:Math.round((available_funds/needed_funds * 100)) + "%"}
                      }
                    }
                    f3_counter++;
                   }else if(curr_qcat_name == "f4" || curr_qcat_name == "f5" || curr_qcat_name == "f6" ||
                            curr_qcat_name == "f7" || curr_qcat_name == "f8" || curr_qcat_name == "f9" ||
                            curr_qcat_name == "f10" || curr_qcat_name == "f11"){
                      if (resobj){
                        all_3_flows = (resobj.value_weight == 3 && all_3_flows);
                        if (resobj.value_weight == 1){
                          count_1_flows++;
                        }
                      }else{
                        var res_val = 0;
                        if (!all_3_flows){
                          res_val = count_1_flows/8
                        }
                        rowresults[rri] = {value:Math.round((res_val*100)).toString()+"%"}
                      }
                   }else if(curr_qcat_name == "f13"){
                      if (resobj){
                        all_3_accountability = (resobj.value_weight == 3 && all_3_accountability);
                        if (resobj.value_weight == 1){
                          count_1_accountability++;
                        }
                      }else{
                        var res_val = 0;
                        if (!all_3_accountability){
                          res_val = count_1_accountability/4
                        }
                        rowresults[rri] = {value:Math.round((res_val*100)).toString()+"%"}
                      }
                   }else if(curr_qcat_name == "f14" || curr_qcat_name == "f15" || curr_qcat_name == "f16" ||
                            curr_qcat_name == "f17" || curr_qcat_name == "f18"){
                      if (resobj){
                        all_3_sources = (resobj.value_weight == 3 && all_3_sources);
                        if (resobj.value_weight == 1){
                          count_1_sources++;
                        }
                      }else{
                        var res_val = 0;
                        if (!all_3_sources){
                          res_val = count_1_sources/5
                        }
                        rowresults[rri] = {value:Math.round((res_val*100)).toString()+"%"}
                      }
                   }else if(curr_qcat_name == "f19" || curr_qcat_name == "f20"){
                      if (resobj){
                        all_3_equity = (resobj.value_weight == 3 && all_3_equity);
                        if (resobj.value_weight == 1){
                          count_1_equity++;
                        }
                      }else{
                        var res_val = 0;
                        if (!all_3_equity){
                          res_val = count_1_equity/12
                        }
                        rowresults[rri] = {value:Math.round((res_val*100)).toString()+"%"}
                      }
                   }
                 }
                 for(var rri = 0; rri < rowresults.length; rri++){
                   if(!rowresults[rri]){
                     rowresults[rri]='to be calculated';
                     data_valid = false;
                   }
                 }
                 if(data_valid) {
                   this.rows.push(this.rowsobj[ri]);
                 }
               }
              this.empty_objects([this.rowsobj,this.qtindexobj]);
              this.qtindexrevarr = null;
              data = null;

this.qctypes_new = [
{'display_text':'1. What is the total expense estimate to reach this indicator by 2030 (\'000,000 USD)',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'2. What is the estimated amount available for this indicator in the current year? (\'000,000 USD)',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'3. What is the estimated amount needed for this indicator in the current year? (\'000,000 USD)',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'Gap in funding - current year (\'000,000 USD)',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'Total available funds as % of funds needed in the current year',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'4. Is there a publicly available and easily accessible financing plan/budget for this indicator?',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'5. Are expenditure reports publicly available and easily accessible for this indicator?',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'6. Do expenditure reports allow actual spending on this indicator to be compared with committed funding?',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'7. Is the percent utilization of official donor capital commitments for this indicator known AND above 75%?',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'8. Is the percent utilization of domestic capital commitments for this indicator known AND above 75%?',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'9. Are there adequate guidance documents that ensure budgeting for this indicator is done adequately?',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'10. Does the lead Government Ministry/Institution have bankable projects to achieve this indicator already prepared?',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'11. Is there an ability to have multi-year budget allocation for this target and is there a long term commitment to funds (minimum of 3 years)?',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'Proportion of positive responses for \'financial flows\'',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'12. Are there are formalised mechanisms for including civil society in the financial planning process  as related to this indicator?',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'13. Is the accountability for this indicator ensured through:',
'rspan':1,'cspan':3,'min_col_width':10},
{'display_text':'Proportion of positive responses for \'accountability\'',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'14. Are public allocations related to this indicator as a percentage of GDP known?',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'15. Is the percentage of ODA (aid) that supports nationally defined policies, plans and activities for this indicator known?',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'16. Is there a functioning domestic bond market which is involved in finance for this indicator?',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'17. Are there legal and institutional frameworks that allow the whole range of financial transactions to take place?',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'18. Are functional financial mechanisms and instruments being used?',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'Proportion of positive responses for \'funding sources\'',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'19. Do incentives for environmentally sustainable, efficient technologies exist in key financial plans for this indicator?',
'rspan':2,'cspan':1,'min_col_width':10},
{'display_text':'20. Are there specific measures in the financing plan to target resources to reduce inequities, as related to the conditions or services linked to this indicator? Consider these following groups:',
'rspan':1,'cspan':11,'min_col_width':10},
{'display_text':'Proportion of positive responses for \'funding for equity\'',
'rspan':2,'cspan':1,'min_col_width':10}];

this.qtypes_new = [
{
'display_text':'a',
'min_col_width':10
},{
'display_text':'b',
'min_col_width':10
},{
'display_text':'c',
'min_col_width':10
},{
'display_text':'a',
'min_col_width':10
},{
'display_text':'b',
'min_col_width':10
},{
'display_text':'c',
'min_col_width':10
},{
'display_text':'d',
'min_col_width':10
},{
'display_text':'e',
'min_col_width':10
},{
'display_text':'f',
'min_col_width':10
},{
'display_text':'g',
'min_col_width':10
},{
'display_text':'h',
'min_col_width':10
},{
'display_text':'i',
'min_col_width':10
},{
'display_text':'j',
'min_col_width':10
},{
'display_text':'l',
'min_col_width':10
}];

for(var i=0;i<this.qctypes_new.length;i++)
this.qctypes_new[i].min_col_width = parseInt((this.qctypes_new[i].display_text.length*1.5).toFixed(0));

for(var i=0;i<this.qtypes_new.length;i++)
this.qtypes_new[i].min_col_width = parseInt((this.qtypes_new[i].display_text.length*1.5).toFixed(0));

             },
             error => {
               this.alertService.error(error);
             });
             data = null;
       },
       error => {
           this.alertService.error(error);
       });
  }

empty_objects(objects_arrays){
  for (var j=0; j<objects_arrays.length; j++){
    var props = Object.getOwnPropertyNames(objects_arrays[j]);
    for (var i = 0; i < props.length; i++) {
      delete objects_arrays[j][props[i]];
    }
  }
}

ngOnDestroy() {
  //  used in template
  this.qcgroups = null;
  this.qctypes = null;
  this.qtypes = null;
  this.rows = null;

  if(this.subscription1)
    this.subscription1.unsubscribe();
  if(this.subscription2)
    this.subscription2.unsubscribe();
}

  financeBtnClick(){
    this.router.navigateByUrl('/sdg/finance')
  }
  quesBtnClick(){
      this.router.navigateByUrl('/sdg/finance-quest')
  }
  dataBtnClick(){
      this.router.navigateByUrl('/sdg/finance-data')
  }
  reportBtnClick(){
      this.router.navigateByUrl('/sdg/finance-report')
  }
}



// WEBPACK FOOTER //
// ./src/app/sdg/finance-data/finance-data.component.ts